import type { ChatMessage } from "~/ai-chat/model/chat-message";
import { ChatMarkdown } from "~/ai-chat/ui/chat-markdown";
import { cn } from "~/utils/cn";

interface ChatMessageBubbleProps {
  message: ChatMessage;
}

export function ChatMessageBubble({ message }: ChatMessageBubbleProps) {
  const isUser = message.role === "user";

  return (
    <div className={cn("flex w-full", isUser ? "justify-end" : "justify-start")}>
      <div
        className={cn(
          "max-w-[85%] rounded-2xl px-3 py-2 text-sm leading-snug break-words",
          isUser ? "bg-accent text-accent-foreground whitespace-pre-wrap" : "bg-primary-50 text-primary-950",
        )}
      >
        {isUser ? message.content : <ChatMarkdown content={message.content} />}
      </div>
    </div>
  );
}

export function ChatMessageTypingBubble({ label }: { label?: string }) {
  return (
    <div role="status" aria-live="polite" aria-atomic="true" className="flex w-full justify-start">
      <span className="sr-only">{label ?? "Istari AI is typing"}</span>
      <div
        className="bg-muted text-muted-foreground flex items-center gap-2 rounded-2xl px-3 py-2.5"
        aria-hidden="true"
      >
        {/* h-4 matches the text-xs line box, so the bubble is the same height with or without a label —
            otherwise it grows ~10px when a tool-activity label appears and the stuck-to-bottom chat jitters. */}
        <span className="flex h-4 items-center gap-1">
          <span className="bg-muted-foreground/60 size-1.5 animate-bounce rounded-full [animation-delay:-0.3s]" />
          <span className="bg-muted-foreground/60 size-1.5 animate-bounce rounded-full [animation-delay:-0.15s]" />
          <span className="bg-muted-foreground/60 size-1.5 animate-bounce rounded-full" />
        </span>
        {label ? <span className="text-xs">{label}</span> : null}
      </div>
    </div>
  );
}
